import React from 'react';
import {
    connect,
    DispatchProp
} from "react-redux";
import {
    orderBy,
} from "lodash";
import { Dice, IRollContext } from '@dndbeyond/dice';
import {
    Ability,
    characterActions,
    CharacterPreferences,
    CharClass,
    rulesEngineSelectors,
    RuleData,
    DecorationInfo,
    DecorationUtils,
} from '@dndbeyond/character-rules-engine/es';
import {
    AbilitySummary,
    CharacterAvatar,
    CharacterAvatarPortrait,
    Collapsible,
    CollapsibleHeaderContent,
    LightLongRestSvg,
} from '@dndbeyond/character-components/es';
import {
    DiceFeatureConfigurationState,
    SharedAppState,
} from '../../../stores/typings';
import {
    SidebarHeader,
    SidebarSubheading,
} from '../../../components/Sidebar';
import {characterRollContextSelectors} from "../../../selectors";
import * as appEnvSelectors from '../../../selectors/appEnv';
import CtaPreferenceManager from '../../../components/CtaPreferenceManager';
import { CurrentDecorationItem } from './CurrentDecorationItem';
import { appEnvActions } from '../../../actions/appEnv';
import { BackdropManager } from './BackdropManager';
import { FrameManager } from './FrameManager';
import { ThemeManager } from './ThemeManager';
import { PortraitManager } from './PortraitManager';


enum SHOP_KEY {
    NONE = 'NONE',
    FRAMES = 'FRAMES',
    BACKDROPS = 'BACKDROPS',
    PORTRAITS = 'PORTRAITS',
    THEMES = 'THEMES',
    PREFERENCES = 'PREFERENCES',
    DICE = 'DICE',
}

interface State {
    currentShop: SHOP_KEY;
}
interface Props extends DispatchProp {
    decorationInfo: DecorationInfo;
    classes: Array<CharClass>;
    name: string;
    ruleData: RuleData;
    isReadonly: boolean;
    preferences: CharacterPreferences;
    diceEnabled: boolean;
    diceFeatureConfiguration: DiceFeatureConfigurationState;
    abilities: Array<Ability>,
    characterRollContext: IRollContext,
}
class DecoratePane extends React.PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            currentShop: SHOP_KEY.NONE
        };
    }

    handleDarkModeToggle = (): void => {
        const {
            dispatch,
            preferences: { enableDarkMode },
        } = this.props;

        dispatch(
            characterActions.preferenceChoose(
                'enableDarkMode',
                !enableDarkMode,
            ),
        );
    };

    //TODO this is repeated a few times now.. reusable thing? hook?
    handleDiceToggle = (): void => {
        const { dispatch, diceEnabled } = this.props;

        const newDiceEnabledSetting: boolean = !diceEnabled;

        try {
            localStorage.setItem(
                'dice-enabled',
                newDiceEnabledSetting.toString(),
            );
            Dice.setEnabled(newDiceEnabledSetting);
        } catch (e) {}

        dispatch(
            appEnvActions.dataSet({
                diceEnabled: newDiceEnabledSetting,
            }),
        );
    };

    handleClick = (type: SHOP_KEY): void => {
        this.setState({
            currentShop: type
        });
    }

    handleCollapseChange = (isCollapsed: boolean, type: SHOP_KEY): void => {
        this.setState({
            currentShop: !isCollapsed ? type : SHOP_KEY.NONE,
        });
    }

    renderPreferences = (): React.ReactNode => {
        const { preferences: { enableDarkMode } } = this.props;

        const headerNode: React.ReactNode = (
            <CollapsibleHeaderContent heading={"Preferences"} />
        );

        return (
            <Collapsible
                header={headerNode}
                layoutType="minimal"
                className="ct-decorate-pane__preferences"
                initiallyCollapsed={false}
            >
                <div className="ct-decorate-pane__preferences-content">
                    <CtaPreferenceManager
                        preferenceEnabled={enableDarkMode}
                        onPreferenceClick={this.handleDarkModeToggle}
                        icon={<LightLongRestSvg />}
                        backgroundImageUrl="https://www.dndbeyond.com/avatars/13574/100/637396156849705602.jpeg"
                        borderColor="#715280"
                        switchColor="#715280"
                        preferenceTitle="Underdark Mode"
                    />
                </div>
            </Collapsible>
        )
    }

    renderDecorateShop = (): React.ReactNode => {
        const { currentShop } = this.state;

        return (
            <div className="ct-decorate-pane__shop">
                <SidebarSubheading>Browse Decorations</SidebarSubheading>

                {/*BACKDROPS*/}
                <Collapsible
                    header="Backdrops"
                    collapsed={currentShop !== SHOP_KEY.BACKDROPS}
                    onChangeHandler={(isCollapsed) => this.handleCollapseChange(isCollapsed, SHOP_KEY.BACKDROPS)}
                >
                    <BackdropManager />
                </Collapsible>

                {/*FRAMES*/}
                <Collapsible
                    header="Frames"
                    collapsed={currentShop !== SHOP_KEY.FRAMES}
                    onChangeHandler={(isCollapsed) => this.handleCollapseChange(isCollapsed, SHOP_KEY.FRAMES)}
                >
                    <FrameManager />
                </Collapsible>

                {/*THEMES*/}
                <Collapsible
                    header="Themes"
                    collapsed={currentShop !== SHOP_KEY.THEMES}
                    onChangeHandler={(isCollapsed) => this.handleCollapseChange(isCollapsed, SHOP_KEY.THEMES)}
                >
                    <ThemeManager />
                </Collapsible>

                {/*PORTRAITS*/}
                <Collapsible
                    header="Portraits"
                    collapsed={currentShop !== SHOP_KEY.PORTRAITS}
                    onChangeHandler={(isCollapsed) => this.handleCollapseChange(isCollapsed, SHOP_KEY.PORTRAITS)}
                >
                    <PortraitManager />
                </Collapsible>

                {/*DICE*/}
                {/*<Collapsible*/}
                {/*    header="Dice"*/}
                {/*    collapsed={currentShop !== SHOP_KEY.DICE}*/}
                {/*    onChangeHandler={(isCollapsed) => this.handleCollapseChange(isCollapsed, SHOP_KEY.DICE)}*/}
                {/*>*/}
                {/*    <div>*/}
                {/*        DICE CHOICE FOR THIS CHARACTER??? HOW NICE!!*/}

                {/*        or could we show a picture at least?*/}
                {/*    </div>*/}
                {/*</Collapsible>*/}
            </div>
        )
    };

    //TODO don't do this twice?
    getHighestScoreAbility = (): Ability => {
        const {
            abilities,
        } = this.props;

        let orderedAbilities =  orderBy(abilities, [
            (ability) => ability.totalScore,
            (ability) => ability.label
        ], ['desc', 'asc']);

        return orderedAbilities[0];
    };

    render() {
        const {
            characterRollContext,
            preferences,
            isReadonly,
            decorationInfo,
        } = this.props;
        const {currentShop} = this.state;
        const avatarInfo = DecorationUtils.getAvatarInfo(decorationInfo);
        const backdropInfo = DecorationUtils.getBackdropInfo(decorationInfo);
        const characterTheme = DecorationUtils.getCharacterTheme(decorationInfo);

        let avatarClasses: Array<string> = [
            'ct-decorate-pane__portrait',
        ];
        if (!avatarInfo.avatarUrl) {
            avatarClasses.push(
                'ct-decorate-pane__portrait--none',
            );
        }

        let backdropClasses: Array<string> = [
            'ct-decorate-pane__backdrop',
        ];
        let backdropStyles: React.CSSProperties = {};
        if (backdropInfo.thumbnailBackdropAvatarUrl) {
            backdropStyles = {
                backgroundImage: `url(${backdropInfo.thumbnailBackdropAvatarUrl})`,
            };
        } else {
            backdropClasses.push(
                'ct-decorate-pane__backdrop--none',
            );
        }

        return (
            <div className="ct-decorate-pane">
                <div className="ct-decorate-pane__current-selections">
                    <SidebarHeader>Current Decorations</SidebarHeader>
                    <div className="ct-decorate-pane__grid">
                        <CurrentDecorationItem
                            label="Portrait"
                            onClick={this.handleClick}
                            decorationKey={SHOP_KEY.PORTRAITS}
                            isActive={currentShop === SHOP_KEY.PORTRAITS}
                            isReadonly={isReadonly}
                        >
                            <CharacterAvatarPortrait className={avatarClasses.join(' ')} avatarUrl={avatarInfo.avatarUrl} />
                        </CurrentDecorationItem>

                        <CurrentDecorationItem
                            label="Frame"
                            onClick={this.handleClick}
                            decorationKey={SHOP_KEY.FRAMES}
                            isActive={currentShop === SHOP_KEY.FRAMES}
                            isReadonly={isReadonly}
                        >
                            <CharacterAvatar
                                avatarInfo={avatarInfo}
                            />
                        </CurrentDecorationItem>

                        <CurrentDecorationItem
                            label="Theme"
                            onClick={this.handleClick}
                            decorationKey={SHOP_KEY.THEMES}
                            isActive={currentShop === SHOP_KEY.THEMES}
                            isReadonly={isReadonly}
                        >
                            <div className="ct-decorate-pane__theme">
                                <AbilitySummary
                                    theme={characterTheme}
                                    ability={this.getHighestScoreAbility()}
                                    preferences={preferences}
                                    diceEnabled={false}
                                    rollContext={characterRollContext}
                                />
                                <div className="ct-decorate-pane__theme-color">{characterTheme.name}</div>
                            </div>
                        </CurrentDecorationItem>

                        <CurrentDecorationItem
                            label="Backdrop"
                            onClick={this.handleClick}
                            decorationKey={SHOP_KEY.BACKDROPS}
                            isActive={currentShop === SHOP_KEY.BACKDROPS}
                            isReadonly={isReadonly}
                        >
                            <div
                                className={backdropClasses.join(' ')}
                                style={backdropStyles}
                            />
                        </CurrentDecorationItem>
                    </div>

                </div>
                {this.renderPreferences()}
                {this.renderDecorateShop()}
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        ruleData: rulesEngineSelectors.getRuleData(state),
        name: rulesEngineSelectors.getName(state),
        decorationInfo: rulesEngineSelectors.getDecorationInfo(state),
        classes: rulesEngineSelectors.getClasses(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
        diceEnabled: appEnvSelectors.getDiceEnabled(state),
        diceFeatureConfiguration:
            appEnvSelectors.getDiceFeatureConfiguration(state),
        preferences: rulesEngineSelectors.getCharacterPreferences(state),
        characterRollContext: characterRollContextSelectors.getCharacterRollContext(state),
        abilities: rulesEngineSelectors.getAbilities(state),
    };
}

export default connect(mapStateToProps)(DecoratePane);
